export const twitterGlobalKeyNS = "twttr";
export const twitterScriptUrl = "https://platform.twitter.com/widgets.js";
